/**
 * @deprecated The access token moved to localStorage — see USER_ACCESS_TOKEN_KEY
 * in `storage.config.ts` for why. This name only exists so sessions that signed
 * in before the move can be migrated and the stale cookie deleted. Remove it,
 * and the migration branch in `auth-storage.service.ts`, once every live session
 * predates the change by more than the refresh-token lifetime (30 days).
 */
export const LEGACY_USER_ACCESS_TOKEN_COOKIE = 'user-token';
export const USER_REFRESH_TOKEN = 'refresh-token';
export const USER_ID_COOKIE_NAME = 'user-uuid';
export const SESSION_CORRELATION_ID = 'sessions-correlation-id';
export const USER_TEAM = 'user-team';
